import { getMarketOverviewBreadcrumbsRoute } from '@/creditflowresearch/ui/common/helpers';

interface IQueryParams {
  regions?: string,
  products?: string,
  dataFrom?: string,
  dataTo?: string,
  hash?: string,
  q?: string,
}

const getBondscreenerBreadcrumbs = (query:IQueryParams) => [
    getMarketOverviewBreadcrumbsRoute(query),
    {
      title: 'Bond Screener',
      isActive: true,
    },
  ];

export default getBondscreenerBreadcrumbs;
